import { navigations } from "helpers/constants";
import { Link, useLocation } from "react-router-dom";

export const MobileNavigation: React.FC = () => {
  const pathName = useLocation().pathname;

  const itemClass = (link: string) =>
    `nav-mobile-item cursor-pointer ${
      pathName === link ? "text-white" : "text-slate-500"
    }`;

  return (
    <>
      <div className="nav-mobile z-0 bg-base-300">
        <div className="flex w-full justify-between items-center py-2 px-4 max-w-3xl mx-auto">
          {navigations.map((item, idx) => (
            <Link key={idx} className={itemClass(item.href)} to={item.href}>
              <i
                className={`${item.icon} ${
                  pathName === item.href
                    ? "text-primary fa-solid"
                    : idx !== 2
                    ? "text-slate-500 fa-thin"
                    : "text-slate-950 fa-solid"
                }`}
              ></i>
              <span className="text-xs leading-none mt-1">{item.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};
